/* eslint-disable import/prefer-default-export */
import { PrivateRoutes } from "../../../../util/routes/routes"
import { INavRoutes } from "../../_config/shape"

// Nav routes definition for the Secondary navigation
export const routes: INavRoutes[] = [
	{
		route: PrivateRoutes.CoachingKit,
		title: "Početna",
	},
	// {
	// 	route: routeVarReplacement(PrivateRoutes.HealthCheckQuiz, [[":id?", ""]]),
	// 	title: "Provera zdravlja",
	// },
	// {
	// 	route: PrivateRoutes.DiscoverTopics,
	// 	title: "Otkrijte poslovanje",
	// },
	{
		route: PrivateRoutes.PlanningListing,
		title: "Planiranje",
	},
	{
		route: PrivateRoutes.CFC,
		title: "Realizacija",
	},
	// {
	// 	route: PrivateRoutes.ChangeLevers,
	// 	title: "Napravi promene",
	// },
	// {
	// 	route: PrivateRoutes.ActionChecklist,
	// 	title: "Čeklista akcija",
	// },
]
